import { render, staticRenderFns } from "./roulette-create.vue?vue&type=template&id=31d18a0e&"
import script from "./roulette-create.vue?vue&type=script&lang=js&"
export * from "./roulette-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports